import { Model } from './model';
import { User } from './user';

export class Ticket extends Model {
  static apiUrl: string = 'tickets';

  descrizione: string;
  stato: string;
  user_id: number;
  user: User;
  allegati: any[] = [];

  deserialize(input: any): Ticket {
    let retV: Ticket = new Ticket();

    retV = super.deserialize(input) as Ticket;

    if (input?.user) {
      retV.user = new User().deserialize(input.user);
    }

    if (input?.allegati) {
      retV.allegati = Array.isArray(input.allegati) ? input.allegati : (input.allegati?.data || []);
    }

    return retV;
  }

  getHumanIdentifier() {
    return `Ticket #${this.id}`;
  }
}
